const testIds = {
  table: "expanses-list",
  row: "expanses-list__row",
  name: "item-name",
  amount: "item-amount",
};

export default testIds;
